
import React, { useState, useEffect } from "react";
import "./WeatherForecast.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

   useEffect(() => {
    setLoaded(false);

    let city = props.city;
    let apiKey = "00a6bfb9b6053b4664t55oaa8c181e51";
    let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=metric`;

   
    axios.get(apiUrl).then(handleResponse).catch(function (error) {
     console.log("There is a problem loading the forecast:", error);
    });
  }, [props.city]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }

  if (loaded) {
    return (
      <div className="WeatherForecast">
        <div className="row g-2">
          {forecast.map(function (dailyForecast, index) {

            if (index < 6) {
              return (
                <div className="col d-flex flex-column justify-content-evenly daily-forecast" key={index}>
                  <WeatherForecastDay data={dailyForecast} />
                </div>
              );
            }
            
            return null;
          })}
        </div>
      </div>
    );
  } else {
    return null;
  }
}